import { History } from "history";

import {
  CreatePromoCodeRequest,
  PromoCodeDto,
  PaginateQuery,
  UpdatePromoCodeRequest,
} from "../../interfaces";
import { Paginated } from "../../models";

//#region Get PromoCodes

export const GET_PROMO_CODES = "GET_PROMO_CODES";
export const GET_PROMO_CODES_SUCCESS: any = "GET_PROMO_CODES_SUCCESS";
export const GET_PROMO_CODES_ERROR: any = "GET_PROMO_CODES_ERROR";

export interface GetPromoCodesAction {
  type: typeof GET_PROMO_CODES;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetPromoCodesSuccessAction {
  type: typeof GET_PROMO_CODES_SUCCESS;
  payload: Paginated<PromoCodeDto>;
}

export interface GetPromoCodesErrorAction {
  type: typeof GET_PROMO_CODES_ERROR;
  payload: any;
}
//#endregion

//#region Get PromoCode

export const GET_PROMO_CODE = "GET_PROMO_CODE";
export const GET_PROMO_CODE_SUCCESS: any = "GET_PROMO_CODE_SUCCESS";
export const GET_PROMO_CODE_ERROR: any = "GET_PROMO_CODE_ERROR";

export interface GetPromoCodeAction {
  type: typeof GET_PROMO_CODE;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetPromoCodeSuccessAction {
  type: typeof GET_PROMO_CODE_SUCCESS;
  payload: PromoCodeDto;
}

export interface GetPromoCodeErrorAction {
  type: typeof GET_PROMO_CODE_ERROR;
  payload: any;
}
//#endregion

//#region Add Promo Code

export const ADD_PROMO_CODE = "ADD_PROMO_CODE";
export const ADD_PROMO_CODE_SUCCESS: any = "ADD_PROMO_CODE_SUCCESS";
export const ADD_PROMO_CODE_ERROR: any = "ADD_PROMO_CODE_ERROR";

export interface AddPromoCodeAction {
  type: typeof ADD_PROMO_CODE;
  payload: {
    request: CreatePromoCodeRequest;
    history: History;
  };
}

export interface AddPromoCodeSuccessAction {
  type: typeof ADD_PROMO_CODE_SUCCESS;
  payload: null;
}

export interface AddPromoCodeErrorAction {
  type: typeof ADD_PROMO_CODE_ERROR;
  payload: any;
}
//#endregion

//#region Update Promo Code

export const UPDATE_PROMO_CODE = "UPDATE_PROMO_CODE";
export const UPDATE_PROMO_CODE_SUCCESS: any = "UPDATE_PROMO_CODE_SUCCESS";
export const UPDATE_PROMO_CODE_ERROR: any = "UPDATE_PROMO_CODE_ERROR";

export interface UpdatePromoCodeAction {
  type: typeof UPDATE_PROMO_CODE;
  payload: {
    id: string;
    request: UpdatePromoCodeRequest;
    history: History;
  };
}

export interface UpdatePromoCodeSuccessAction {
  type: typeof UPDATE_PROMO_CODE_SUCCESS;
  payload: null;
}

export interface UpdatePromoCodeErrorAction {
  type: typeof UPDATE_PROMO_CODE_ERROR;
  payload: any;
}
//#endregion

//#region Delete PromoCode

export const DELETE_PROMO_CODE_CONSENT: any = "DELETE_PROMO_CODE_CONSENT";
export const DELETE_PROMO_CODE = "DELETE_PROMO_CODE";
export const DELETE_PROMO_CODE_SUCCESS: any = "DELETE_PROMO_CODE_SUCCESS";
export const DELETE_PROMO_CODE_ERROR: any = "DELETE_PROMO_CODE_ERROR";

export interface DeletePromoCodeConsentAction {
  type: typeof DELETE_PROMO_CODE_CONSENT;
  payload: string;
}

export interface DeletePromoCodeAction {
  type: typeof DELETE_PROMO_CODE;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeletePromoCodeSuccessAction {
  type: typeof DELETE_PROMO_CODE_SUCCESS;
  payload: null;
}

export interface DeletePromoCodeErrorAction {
  type: typeof DELETE_PROMO_CODE_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetPromoCodesAction
  | GetPromoCodesSuccessAction
  | GetPromoCodesErrorAction
  | GetPromoCodeAction
  | GetPromoCodeSuccessAction
  | GetPromoCodeErrorAction
  | AddPromoCodeAction
  | AddPromoCodeSuccessAction
  | AddPromoCodeErrorAction
  | UpdatePromoCodeAction
  | UpdatePromoCodeSuccessAction
  | UpdatePromoCodeErrorAction
  | DeletePromoCodeConsentAction
  | DeletePromoCodeAction
  | DeletePromoCodeSuccessAction
  | DeletePromoCodeErrorAction;
